export function getParamValue(query: string, param: string) {
  return new URLSearchParams(query).get(param) ?? "";
}
